import { gql as apolloGql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';

/**
 * Apollo Client 4 infers `data` as `unknown` for plain (untyped) `gql`
 * documents, whereas Apollo Client 3 inferred `any`. This project defines its
 * operations as untyped `gql` documents (no GraphQL codegen), so every
 * `useQuery` / `useMutation` / `useLazyQuery` call relied on the v3 `any`
 * behavior for `data` and `variables`.
 *
 * This thin wrapper preserves that behavior by tagging documents as
 * `TypedDocumentNode<any, any>`. It is intentionally isolated to a single file.
 * The long-term, type-safe path is to adopt GraphQL codegen and emit real
 * `TypedDocumentNode` types per operation, at which point this shim can be
 * removed.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function gql(
    literals: TemplateStringsArray | readonly string[],
    ...args: unknown[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): TypedDocumentNode<any, any> {
    return apolloGql(
        literals as TemplateStringsArray,
        ...(args as Parameters<typeof apolloGql>[1][])
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as TypedDocumentNode<any, any>;
}
